// extracted by mini-css-extract-plugin
export default {"studio-thumbnails":"studioThumbnails_studio-thumbnails__VkvVw","actions":"studioThumbnails_actions__ovJvX"};